import Vue from 'vue'
import Vuex from 'vuex'

import events from '@/store/services/events'
import participants from '@/store/services/participants'
import wishlists from '@/store/services/wishlists'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    events,
    participants,
    wishlists,
  },
  strict: true
})

export default store
